import React from 'react';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import _get from 'lodash/get';
import { getValidityHintIcon } from '@lib/utils/validityHint';
import styles from '../Select.module.scss';

function ValidityHintOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti } = restProps;
  const value = _get(restProps, 'value', '') as string;
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.validityHintOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {getValidityHintIcon(value)}
      {children}
    </DefaultSelectComponents.Option>
  );
}

export default ValidityHintOption;
